import React, { useState, useEffect } from 'react';
import '../../../scss/components/pages/staffList.scss';
import swal from 'sweetalert2';

import API from '../../../middleware/API';
import moment from 'moment';
import axios from 'axios';
import { lowerCase } from 'lodash';
import Slider from 'react-slick';
import Pagination from '../../Pagination';
import {useDispatch} from 'react-redux';
import ReviewLeave from '../../ReviewLeave'
import {yearNames,GetStoreRole,GetStoreDetailRole} from '../../../const/constant';

const SigningLeaveRec = () => {
  const [leaveRecList, setLeaveRecList] = useState ([]);
  const [allLeaveRecList, setAllLeaveRecList] = useState ([]);
  const [leaveTypeList, setLeaveTypeList] = useState ([]);
  const [checkedLeaveRecList, setcheckedLeaveRecList] = useState ([]);
  const [isEditShow, setIsEditShow] = useState (false);
  const [status, setStatus] = useState ('S');
  const [editTarget, setEditTarget] = useState ({});
  const [keyword, setKeyword] = useState ('');
  const [loading, setLoading] = useState (true);
  const [reload, doReload] = useState (false);
  const [currPage, setCurrPage] = useState (1);
  const [leaveTypeId, setLeaveTypeId] = useState (-1);
  const [year, setYear] = useState(moment().year());
  const [totalPage, setTotalPage] = useState (0);
  const [countOfPage, setCountOfPage] = useState (10);
  const [query, setQuery] = useState("");
  const role =  GetStoreRole(localStorage.getItem('current_store_id'))  ;
  const detailrole =  GetStoreDetailRole(localStorage.getItem('current_store_id'))  ;

  const dispatch = useDispatch()
  useEffect(() => {
    const timeOutId = setTimeout(() => setKeyword(query), 1500);
    return () => clearTimeout(timeOutId);
  }, [query]);
  useEffect(
    ()=>{
      setLoading(true)
      var url = 'LeaveRec/Pending/'+status + '?year='+year+'&type='+leaveTypeId+'&page='+currPage;

      if(keyword.length > 0)
        url = url + '&keyword=' + keyword;

      axios.all([
        API.get(`/Leave`),
        API.get(url),
      ]).then(
        axios.spread((leaveTypeList, res) => {
          dispatch({ type: 'GET_ALL_LEAVEREC_SUCCESS',result:res})
          setAllLeaveRecList(res)
          setLeaveTypeList(leaveTypeList);
          //setLeaveRecList(res.slice((currPage - 1) * countOfPage, ((currPage - 1) * countOfPage) + countOfPage))
          setLeaveRecList(res.leaveRecList)
          setTotalPage(Math.ceil(res.totalCount / 10))
          //setTotalPage(res.totalCount)
          setcheckedLeaveRecList(res.leaveRecList)
          setLoading(false)
        })
      );    
    }
  ,[reload, keyword, status, year, leaveTypeId, currPage]);

  // useEffect(
  //   ()=>{
  //     //setLeaveRecList(allLeaveRecList.slice((currPage - 1) * countOfPage, ((currPage - 1) * countOfPage) + countOfPage))
  //     setLeaveRecList(allLeaveRecList)
    
  //   }
  // ,[currPage]);

  const signingSingleRec = (id, status) => {
    swal({
        type: 'info',
        input: 'text',
        title: '輸入備註(選填)',
        showConfirmButton: true,
        showCloseButton: true,
        heightAuto: false
      }).then((result) => {
        if(!result.dismiss)  {
            let data = {
                leaveIds: id,
                status: status,
                note: result.value,
                leaveHours: 0
            }
        
            API.put('LeaveRec/Signing', data).then((res) => {
                if (res) {
                  doReload(!reload);    
                }
              });             
        }
      })
};
  const signingMultiRec = (status) => {
    swal({
      type: 'info',
      input: 'text',
      title: '輸入備註(選填)',
      showConfirmButton: true,
      showCloseButton: true,
      heightAuto: false
    }).then((result) => {
      if(!result.dismiss)  {
        var signingIds = '';
        checkedLeaveRecList.forEach((checkedLeaveRec) => {
          if (checkedLeaveRec.isChecked){
            signingIds = signingIds + checkedLeaveRec.id  + ','
          }        
        });
        let data = {
          leaveIds: signingIds.slice(0, -1),
          status: '1',
          note:result.value,
          leaveHours: 0,
        }
      
        API.put('LeaveRec/Signing', data).then((res) => {
          if (res) {
          doReload(!reload);    
          }
        }); 
      }
    })
  };
  const signingRecNew = (id, status, comment, leaveHours) => {
    let data = {
      leaveIds: id,
      status: status,
      note: comment,
      leaveHours: leaveHours
    }

    API.put('LeaveRec/Signing', data).then((res) => {
      if (res) {
        setIsEditShow(false);
        doReload(!reload);    
      }
    });             
  };
  const updateLeaveHours = (key,e)=>{
    setEditTarget({...editTarget,leaveHours:e.target.value});
  }

  const handleChangePage = (page) => {
    setCurrPage(page);
    //doReload(!reload);
  }

  const diff = (start, end) => {
    var startMoment = moment(start);
    var endMoment = moment(end);
    
    return (endMoment - startMoment) / 1000 / 60 / 60; 
  }
  const handleCheckChieldElement = (event) => {
    let fruites = checkedLeaveRecList;
    console.log(fruites)
    fruites.forEach((leaveRec) => {       
      if (leaveRec.id === parseInt(event.target.value))
      {
          leaveRec.isChecked =  event.target.checked
      }
    })
    setcheckedLeaveRecList(fruites);
  }

  const settings = {
    dots: true,
    arrows: false,
  };

  const slides = leaveRecList.map((leaveRec, index) => (
    <div key={leaveRec.id}>
    <table className="u-table u-table-border u-table-striped u-table-media-phone">
      <tbody>
        <tr>
          <th>假單ID</th>
          <td>{leaveRec.id}</td>
        </tr>
        <tr>
          <th>姓名</th>
          <td>{leaveRec.applyUser.realName}</td>
        </tr>
        <tr>
        <th>預期請假日</th>
        <td>{moment(leaveRec.applyDate).format('YYYY-MM-DD')}</td>
        </tr>
        <tr>
        <th>打卡時間</th>
        <td>
        { 
          leaveRec.records.data.length > 0 ?
            leaveRec.records.data.map(actualEvent=>
              <React.Fragment key={actualEvent.id}>
                <span>{actualEvent.actualSignInTime} ~ {actualEvent.actualSignOutTime}</span><br/>
              </React.Fragment>)
              :''
        }
        </td>
        </tr>
        <tr>
        <th>打卡時數</th>
        <td>
        { 
        leaveRec.records.data.length > 0 ?
        leaveRec.records.totalWorkTime
          :''
         
        }
        </td>
        
        </tr>
        <tr>
        <th>請假時間</th>
        <td>{moment(leaveRec.sDate).format('HH:mm')} ~ {moment(leaveRec.eDate).format('HH:mm')}</td>
        </tr>
        <tr>
        <th>請假時數</th>
        <td>
                  {leaveRec.leaveHours}
        {/* {leaveRec.leaveHours ? leaveRec.leaveHours :diff(leaveRec.sDate, leaveRec.eDate)} */}
        {leaveRec.leaveItemId === 1? 
        (<span> / <span style={{color:'red'}}>{leaveRec.remainHours}</span>(剩餘特休)</span>  ) :
        leaveRec.leaveItemId === 23? 
        (<span> / <span style={{color:'red'}}>{leaveRec.compensatoryHours}</span>(剩餘補休)</span>  ) :
        ''}
        </td>
        </tr>
        <tr>
        <th>職務代理人</th>
        <td>{leaveRec.agentUser ? leaveRec.agentUser.realName : '無'}</td>
        </tr>
        <tr>
        <th>假別</th>
        <td>{leaveRec.leaveTypeName}</td>
        </tr>
        <tr>
        <th>事由</th>
        <td style={{whiteSpace:'break-spaces'}}>{leaveRec.reasons ? leaveRec.reasons : '未填寫'}</td>
        </tr>
        <tr>
        <th>簽核</th>
        {detailrole == '15'?'':
          status !== 'X'? status === 'S'?
          <td>
{
            leaveRec.fileName?<>
            <button onClick={() => {window.open(leaveRec.fileName, "_blank")}}>附件</button> <br/>
            </>:''
          }
          <button className="btn btn-md save" onClick={() => {
                setIsEditShow(true)
                setEditTarget(leaveRec)
                }}>簽核</button>
          </td>:<td>
            {
            leaveRec.fileName?<>
            <button onClick={() => {window.open(leaveRec.fileName, "_blank")}}>附件</button> <br/>
            </>:''
          }<button className="btn btn-md delete" onClick={() => signingSingleRec(leaveRec.id, 'X')}>作廢</button></td>:<td style={{display:'none'}}></td>  

        }

        </tr>
        
      </tbody>
    </table>
  </div>
  ))
  if (loading) {
    return (
      <div className="loading__overlay">
        <div className="loading__content">
          <div className="spinner" />
        </div>
      </div>
    );
  }
  
 return(
  <div className="p-signTime">
  <div className="u-block u-block--fixHeight">
      <div className="u-title">待簽核假單列表
        <a
              href="https://docs.google.com/presentation/d/1LymJWB_-odjUthdb-PprWznaOKYDabYoLK2JxJhAVrQ/edit?usp=sharing"
              className="u-how-use"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fas fa-question-circle" />
          </a>
      </div>

      <div className="u-search-box">
      <div className="p-0  u-table-media">
      {
        status === 'S' && leaveRecList.length > 0?
        <>
          <button className="btn btn-md success" onClick={() => signingMultiRec('1')}>選取核准</button>
        </>
        :
        ''
      }

      </div>
          <div className="date-input">
          <input className="u-form__input" value={query} placeholder="請輸入姓名" onChange={(e)=>{setQuery(e.target.value); setCurrPage(1)}} />
          <span className="mobile-hide"style={{ flex: '0 0 0px' }}>假別：</span>

<select value={leaveTypeId} className="u-form__select" 
              onChange={(e)=>{setLeaveTypeId(e.target.value); setCurrPage(1)}}
            >
              <option value="-1">全部</option>
              {
                leaveTypeList.filter(leaveType => leaveType.enable).map(leaveType => (
                  <option key={leaveType.id} value={leaveType.id}>{ leaveType.name }</option>
                ))
              }
            </select>
          <span className="mobile-hide"style={{ flex: '0 0 0px' }}>狀態：</span>

            <select style={{minWidth:"56px"}} value={status} onChange={(e)=>{setStatus(e.target.value); setCurrPage(1)}} className="u-form__select">
            <option value="S">送簽</option>
            <option value="1">核准</option>
            <option value="X">作廢</option>
            </select>

            <span className="mobile-hide"style={{ flex: '0 0 0px' }}>請假年度：</span>

            <select style={{minWidth:"56px"}} value={year} onChange={(e)=>{setYear(e.target.value); setCurrPage(1)}} className="u-form__select">
            {
                yearNames.map(yearName => (
                  <option key={yearName} value={yearName}>{ yearName }</option>
                ))
              }


            </select>
          </div>
          
        </div>

      <div className="u-table-responsive">    
      <table className="u-table u-table-border u-table-striped u-table-media">
          <thead>
            <tr>
                {
                  status === 'S'? 
                  <th style={{width:'30px'}}></th>
                  :<th style={{display:'none'}}></th>
                }
                <th>假單ID</th>
                <th>姓名</th>
                <th>預期請假日</th>
                <th>預期簽到退時間</th>
                <th>打卡時間</th>
                <th>打卡時數</th>

                <th>請假時間</th>
                <th>請假時數</th>
                <th>職務代理人</th>
                <th>假別</th>
                {
                  status === '1'? 
                  <th style={{width:'30px'}}>簽核人</th>:
                  status === 'X'? <th style={{width:'30px'}}>作廢人</th>
                  :<th style={{display:'none'}}></th>
                }
                {detailrole == '15'?'':
                  status !== 'X'? <th>操作</th> :<th style={{display:'none'}}>操作</th>
                }
                                <th>送簽日 / 簽核日</th>

            </tr>
          </thead>
            {
              leaveRecList.filter(m=>m.status === status).map(leaveRec => (
                <tbody key={leaveRec.id}>
                <tr>
                        {
                          status === 'S'? 
                          <td rowSpan='3'>
                            <input className='checkmark' key={leaveRec.id} onClick={handleCheckChieldElement} type="checkbox" checked={leaveRec.isChecked} value={leaveRec.id} />
                          </td>
                          :<td style={{display:'none'}}></td>
                        }

                        <td style={{verticalAlign:'middle'}}>{leaveRec.id}</td>
                        <td style={{verticalAlign:'middle'}}>{leaveRec.applyUser.realName}</td>
                        <td style={{verticalAlign:'middle'}}>{moment(leaveRec.applyDate).format('YYYY-MM-DD')}</td>
                        <td style={{verticalAlign:'middle'}}>{leaveRec.targetEvent ?`${moment(leaveRec.targetEvent.start).format('HH:mm')}~`+`${moment(leaveRec.targetEvent.end).format('HH:mm')}`:'預期事件已刪除'}</td>
                        
                        <td style={{verticalAlign:'middle'}}>{
                          leaveRec.records.data.length > 0 ?
                          leaveRec.records.data.map(actualEvent=>
                            <React.Fragment key={actualEvent.id}>
                              <span>{actualEvent.actualSignInTime} ~ {actualEvent.actualSignOutTime}</span><br/>
                            </React.Fragment>):''

                        }</td>
                        <td>
                        { 
                          leaveRec.records.data.length > 0 ?
                          leaveRec.records.totalWorkTime
                            :''
                          
                          }
                        </td>
                        <td style={{verticalAlign:'middle'}}>{moment(leaveRec.sDate).format('HH:mm')} ~ {moment(leaveRec.eDate).format('HH:mm')}</td>
                        <td style={{verticalAlign:'middle'}}>
                          {leaveRec.leaveHours}
                          {/* {leaveRec.leaveHours ? leaveRec.leaveHours :diff(leaveRec.sDate, leaveRec.eDate)} */}
                          {leaveRec.leaveItemId === 1? 
                          (<span> / <span style={{color:'red'}}>{leaveRec.remainHours}</span>(剩餘特休)</span>  ) :
                          leaveRec.leaveItemId === 23? 
                          (<span> / <span style={{color:'red'}}>{leaveRec.compensatoryHours}</span>(剩餘補休)</span>  ) :
                          ''}
                        </td>
                        <td style={{verticalAlign:'middle'}}>{leaveRec.agentUser ? leaveRec.agentUser.realName : '無'}</td>
                        <td style={{verticalAlign:'middle'}}>{leaveRec.leaveTypeName}</td>
                        {
                          status === '1'? 
                          <td>{leaveRec.approveUser.realName}</td>:
                          status === 'X'? 
                          <td>{leaveRec.modifiedUserName}<br/>{moment(leaveRec.modifiedDate).format('YYYY-MM-DD hh:mm:ss')}</td>
                          :<td style={{display:'none'}}></td>
                        }
                        {detailrole == '15'?'':
                          status !== 'X'? status === 'S'?
                          <td>
                            {
                              leaveRec.fileName?<>
                              <button onClick={() => {window.open(leaveRec.fileName, "_blank")}}>附件</button> <br/>
                              </>:''
                            }
                          <button className="btn btn-md save" onClick={() => {
                                setIsEditShow(true)
                                setEditTarget(leaveRec)
                                //signingSingleRec(leaveRec.id, '1');
                                }}>簽核</button>
                          </td>:<td>
                            {
                              leaveRec.fileName?<>
                              <button onClick={()=> {window.open(leaveRec.fileName, "_blank")}}>附件</button> <br/>
                              </>:''
                            }  <button className="btn btn-md delete" onClick={() => signingSingleRec(leaveRec.id, 'X')}>作廢</button></td>:<td style={{display:'none'}}></td>  
                        }
                        <td style={{verticalAlign:'middle'}}>{moment(leaveRec.sendDate).format('YYYY-MM-DD')}{moment(leaveRec.approveDate).format('YYYY-MM-DD') !== '0001-01-01'? ' / '+moment(leaveRec.approveDate).format('YYYY-MM-DD'): ' / 尚未簽核'} </td>


                    </tr>
                    <tr>
                        <td colSpan='10' style={{textAlign:'left'}}>事由：{leaveRec.reasons ? leaveRec.reasons : '未填寫'}</td>
                    </tr>
                    <tr>
                        <td colSpan='10' style={{textAlign:'left'}}>備註：{leaveRec.notes ? leaveRec.notes : '無備註'}</td>
                    </tr>
                </tbody>

                )
              )
            }
        </table>
      </div>
      {
        leaveRecList.length > 0 ? <Slider {...settings}>
        {
          slides
        }
      </Slider>:''
      }
      <div className="pagination-box">
        <Pagination 
            currPage={currPage} totalPage={totalPage}
            onChangPage={handleChangePage}
        />
      </div>
      <ReviewLeave 
          isVisible={isEditShow} 
          toggleOpen={()=>{setIsEditShow(!isEditShow);}} 
          allLeaveType={leaveTypeList} 
          editTarget={editTarget}
          signingFunc={signingRecNew}
          onChangeFunc={updateLeaveHours}
        />
    </div>
  </div>
 );
}

export default SigningLeaveRec

